module.exports = new __parcel__URL__("hud_battle_royale_text.116d5352.png").toString();